import { render, staticRenderFns } from "./AddWorklistModal.vue?vue&type=template&id=5a939b7f"
import script from "./AddWorklistModal.vue?vue&type=script&lang=js"
export * from "./AddWorklistModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports